/* eslint-disable @typescript-eslint/no-unsafe-argument */
// import { ICountryListResponse } from 'services/countryList';
import { create } from 'zustand';
import { createJSONStorage, persist } from 'zustand/middleware';

type IReportStatusStore = {
  activeSubStepId: any;
  renderNextStep: any;
  isContinueDisabled: any;
  dataValidationDrawerOpen: any;
  activeStepId: number;
  loading: any;
  dataValidationTableLoading: boolean;
  missingFieldsCountStore: any;
  setIsContinueDisabled: any;
  setRenderNextStep: any;
  setActiveSubStepId: any;
  setActiveStepId: any;
  setdataValidationDrawerOpen: any;
  setMissingFieldsCountStore: (count: any) => void;
  setLoading: any;
  setDataValidationTableLoading: (value: boolean) => void;
  customGroupContinueHandler: (() => Promise<boolean>) | null;
  setCustomGroupContinueHandler: (handler: (() => Promise<boolean>) | null) => void;
};
const initialState = {
  activeSubStepId: 0,
  renderNextStep: false,
  isContinueDisabled: true,
  dataValidationDrawerOpen: false,
  activeStepId: 0,
  loading: false,
  dataValidationTableLoading: false,
  missingFieldsCountStore: 0,
  customGroupContinueHandler: null,
};

//  needs to be optimized
export const useReportStatusStore = create<IReportStatusStore, [['zustand/persist', unknown]]>(
  persist(
    (set) => ({
      ...initialState,
      setIsContinueDisabled: (data: any) => {
        set({ isContinueDisabled: data });
      },
      setRenderNextStep: (data: any) => {
        set({ renderNextStep: data });
      },
      setActiveSubStepId: (data: any) => {
        set({ activeSubStepId: data });
      },
      setActiveStepId: (data: any) => {
        set({ activeStepId: data });
      },
      setdataValidationDrawerOpen: (data: any) => {
        set({ dataValidationDrawerOpen: data });
      },
      setMissingFieldsCountStore: (data: any) => {
        set({ missingFieldsCountStore: data });
      },
      setLoading: (data: any) => {
        set({ loading: data });
      },
      setDataValidationTableLoading: (value: boolean) => {
        set({ dataValidationTableLoading: value });
      },
      setCustomGroupContinueHandler: (handler: (() => Promise<boolean>) | null) => {
        set({ customGroupContinueHandler: handler });
      },
    }),
    {
      name: 'kf1-reportStatusStore', // name of the item in the storage (must be unique)
      storage: createJSONStorage(() => window.sessionStorage), // (optional) by default, 'localStorage' is used
      partialize: (state) => ({
        activeSubStepId: state.activeSubStepId,
        renderNextStep: state.renderNextStep,
        isContinueDisabled: state.isContinueDisabled,
        dataValidationDrawerOpen: state.dataValidationDrawerOpen,
        activeStepId: state.activeStepId,
        loading: state.loading,
        missingFieldsCountStore: state.missingFieldsCountStore,
      }),
    },
  ),
);
